export const dnevniRitem = [
  {
    id: "jutro",
    cas: "06.00 – 11.00",
    naslov: "Jutranji mir",
    opis:
      "Prva kava, tišji kotiček in dovolj časa, da se dan začne brez hitenja.",
  },
  {
    id: "popoldne",
    cas: "11.00 – 17.00",
    naslov: "Popoldanski oddih",
    opis:
      "Kratek odklop med opravki, ko si zaželite mirnega prostora in sproščenega premora.",
  },
  {
    id: "vecer",
    cas: "17.00 – 22.00",
    naslov: "Večerni pogovor",
    opis:
      "Počasnejši tempo, prijetna družba in prostor, kjer se klepet ne konča na hitro.",
  },
];